import React from "react";
import Rail from "../layout/Rail";
import Sheet from "../layout/Sheet";
import Hero from "../sections/Hero";
import About from "../sections/About";
import Work from "../sections/Work";
import Skills from "../sections/Skills";
import Experience from "../sections/Experience";
import Contact from "../sections/Contact";

const Home = () => (
  <>
    <Rail />
    <Sheet revealId="contact" footer={<Contact />}>
      <main>
        <Hero />
        <About />
        <Work />
        <Skills />
        <Experience />
      </main>
    </Sheet>
  </>
);

export default Home;
